import { IPatient } from "../models/patient";

export const patientKey = (patient: IPatient): string => {
    const phone = patient.phone?.replace('(', '').replace(')', '').replace('-', '').replace(' ', '');
    return `${patient.firstName.toLowerCase()}-${patient.lastName.toLowerCase()}-${phone}`;
}